import { useEmbedPopover } from "./use-embed-popover";
import { EMBED_SELECT_MSG } from "./use-embed-page";

export const useEmbedPopoverSelect = (
  targetUrn,
  { onDisclose, ...config } = {}
) =>
  useEmbedPopover(targetUrn, {
    ...config,
    scope: config.scope || "select",
    events: {
      ...(config.events || {}),
      [EMBED_SELECT_MSG]: onDisclose
    }
  });
